import { cn } from '@costar-ui/cosmos';
import React__default, { useMemo } from 'react';
import { useComponentTheme } from '../../theme/theme.context.esm.js';

var circleStyles = {
  transition: 'stroke 225ms linear 0s',
  strokeDasharray: '282.743px'
};
var Spinner = function Spinner(props) {
  var theme = useComponentTheme('Spinner');
  var _props$color = props.color,
    color = _props$color === void 0 ? 'on-base' : _props$color,
    _props$size = props.size,
    size = _props$size === void 0 ? 'sm' : _props$size,
    _props$strokeWidth = props.strokeWidth,
    strokeWidth = _props$strokeWidth === void 0 ? 4 : _props$strokeWidth,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className;
  var classes = useMemo(function () {
    return cn('animate-spinner-linear-rotate', theme({
      className: className,
      color: color,
      size: size
    }));
  }, [className, color, size, theme]);
  return /*#__PURE__*/React__default.createElement("svg", {
    className: classes,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: strokeWidth,
    preserveAspectRatio: "xMidYMid meet"
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: "50%",
    cy: "50%",
    r: "45",
    className: "origin-center animate-spinner-stroke-rotation fill-transparent stroke-[10%]",
    style: circleStyles
  }));
};
Spinner.displayName = 'Spinner';
var Spinner$1 = Spinner;

export { Spinner$1 as default };
//# sourceMappingURL=spinner.esm.js.map
